export enum CustomerDetailTab {
    Customer,
    Vehicle,
    MVDNow,
    Correspondence,
    Documents,
    Affiliations,
    VehicleDetails,
    Accounts,
    AccountDetails,
    AccountEdit,
    DisbursementRequest,
    ServiceHistory,
    CustomerServiceHistory,
    DriverInformation
}
